<script>
    import { onMount } from "svelte";

    export let size = "1.5rem";
    export let timeInterval = 10;
    export let manualClass = "";

    let interval,
        percent = 0;

    onMount(() => {
        clearInterval(interval);

        percent = 0;

        interval = setInterval(() => {
            if (percent < 100) percent += 1;
            else percent = 0;
        }, timeInterval);
    });
</script>

<div
    class={`radial-progress border-secondary ${manualClass}`}
    style={`--size: ${size}; --value:${percent}`}
/>
